import React from 'react';
import PropTypes from 'prop-types';

const HTMLContent = (props) => {
    const { content } = props;
    const html = {
        __html: content.replace(/(<? *script)/gi, ''),
    };

    /* Disable linting as component purpose is to handle 'dangerouslySetInnerHTML' */
    /* eslint-disable react/no-danger */
    return (
        <div
            dangerouslySetInnerHTML={html}
        />
    );
    /* eslint-enable react/no-danger */
};

HTMLContent.propTypes = {
    content: PropTypes.string,
};

HTMLContent.defaultProps = {
    content: '',
};

export default HTMLContent;
